import { baseURL } from "../utilits/config";
import axios from "axios";

export function addStuffs(stuffData, callback){
     const config = {
          method: "post",
          url : baseURL + "/add-stuffs",
          headers : {
             "Content-Type" : "application/json",
          },
          data : stuffData,
     };

     axios(config)
          .then((result) =>{
              callback(result.data);
          })
          .catch((error) =>{
              callback(error);
          })
}

export function getStuffs(callback){
      const config ={
           method : "get",
           url : baseURL + "/add-stuffs",
           headers : {},
      };

      axios(config)
           .then((result) =>{
              callback(result.data);
           })
           .catch((error) =>{
                callback(error);
           })
}